module.exports = __webpack_public_path__ + "media/images/course/__depo_01-69f6541f78b38fcca06cca63a24fc9ee.png";